import React from 'react'
import { mobile } from './tokens'

interface MobileSectionProps {
  title?: string
  description?: string
  children: React.ReactNode
  className?: string
  /** Flush content (no inner padding) — for nested lists */
  flush?: boolean
  actions?: React.ReactNode
}

export function MobileSection({
  title,
  description,
  children,
  className = '',
  flush,
  actions,
}: MobileSectionProps) {
  return (
    <section className={`${mobile.surface} ${className}`.trim()}>
      {(title || actions) && (
        <div className="flex items-center justify-between gap-2 px-4 pt-3.5 pb-2">
          <div className="min-w-0">
            {title && <h2 className="text-base font-semibold text-gray-900">{title}</h2>}
            {description && <p className="text-xs text-gray-500 mt-0.5">{description}</p>}
          </div>
          {actions}
        </div>
      )}
      <div className={flush ? '' : title ? 'px-4 pb-4' : 'p-4'}>{children}</div>
    </section>
  )
}
